import React from 'react';
import Table from 'react-bootstrap/Table';

import Display from '../../util/Display';
import DisplayPhone from '../common/DisplayPhone';
import DisplayEmail from '../common/DisplayEmail';

/**
 * this will show lead image and all primary information
 */
class PropertyDetails extends React.Component {

  constructor(props) {
    super(props);
    this.setLeadInfo(props);
    this.id = props.property.id;
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.property && props.property.id !== this.id) {
      this.setLeadInfo(props);
    }
  }

  setLeadInfo = props => {
    const field = 'responsible_person';
    this.owners = Display.FieldValue(props.property, field, props.model.fields);

    var phones = props.property.phone;
    this.phones = [];
    if (phones && phones !== '' && phones !== '~~') {
      phones = phones.substring(1, phones.length - 1);
      phones = phones.split('~');
      this.phones = phones.map(phone => <DisplayPhone key={`p_d_${phone}`} phone={phone} />);
    }

    var emails = props.property.email;
    this.emails = [];
    if (emails && emails !== '' && emails !== '~~') {
      emails = emails.substring(1, emails.length - 1);
      emails = emails.split('~');
      this.emails = emails.map(email => <DisplayEmail key={`p_e_${email}`} email={email} />);
    }
  };

  render() {
    return (
      <div className="row">
        <div className="col-md-4"></div>
        <div className="col-md-8 leadsec">
          <Table className="table-sm table-borderless">
            <tbody>
              <tr> <th>Lead Owner</th> <td>{this.owners ? this.owners : '-'}</td> </tr>
              {/* <tr> <th>Phone</th> <td>{this.phones ? this.phones : '-'}</td> </tr>
              <tr> <th>Email</th> <td>{this.emails ? this.emails : '-'}</td> </tr> */}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}

export default PropertyDetails;